import { defineStore } from 'pinia'
import { authStore } from '../index';
import axios from 'axios';

export const useRealtimeApiStore = defineStore('realtimeApi', () => {
    const axiosInstance = () => {
        const auth = authStore();
        const authHeader = `Bearer ${auth.user.id_token}`;
        const axiosInstance = axios.create({
            // TODO
            baseURL: process.env.VUE_APP_GAMEMANAGE_URL,
            headers: {
                common: {
                    Authorization: authHeader
                }
            }
        });
        axiosInstance.interceptors.request.use((request) => {
            request.transformResponse = [data => data]
            return request
        });
        axiosInstance.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            return error
        });
        return axiosInstance;
    }

    /**
     * 
     * Matches
     * 
     */


    /**
     * Retrieve a Match by id
     * @param Id String
     * @returns Object with match data
     * {
        "id": "1",
        "startDate": "2021-08-04T10:00:00Z",
        "finishDate": "2021-08-08T18:00:00Z",
        "matchDays": [
            "string"
        ],
        "matchType": "Test",
        "sessions": [object],
        "gender": "Female",
        "winner": {
            "id": "1",
            "name": "string"
        },
        "toss": {
            "id": "1",
            "name": "string"
        },
        "tossDecision": "Bat",
        "umpires": object,
        "result": "Win",
        "team1": object,
        "team2": object,
        "season": "2023-24",
        "series": {
            "name": "string"
        },
        "venue": {
            "id": "string",
            "name": "string",
            "city": "string",
            "country": "AUS"
        }
     */
    const getMatchById = async (Id: any) => {
        try {
            return await axiosInstance().get(`gamemanager/matches/${Id}`);
        } catch (error) {
            return handleError(error);
        }
    }

    /**
     * Retrieve all matches
     * @param params - object of optional params
     * @returns Objects with match data
         * {
        "cursor": "abc",
        "count": 10,
        "data": [
            "id": "1",
            "startDate": "2021-08-04T10:00:00Z",
            "finishDate": "2021-08-08T18:00:00Z",
            "matchDays": [
                "string"
            ],
            "matchType": "Test",
            "sessions": [object],
            "gender": "Female",
            "winner": {
                "id": "1",
                "name": "string"
            },
            "toss": {
                "id": "1",
                "name": "string"
            },
            "tossDecision": "Bat",
            "umpires": object,
            "result": "Win",
            "team1": object,
            "team2": object,
            "season": "2023-24",
            "series": {
                "name": "string"
            },
            "venue": {
                "id": "string",
                "name": "string",
                "city": "string",
                "country": "AUS"
            }
        ]
        }
         */
    const getAllMatches = async (params?: any) => {
        try {
            const searchParams = new URLSearchParams(params)
            const response = await axiosInstance().get(`gamemanager/matches?${searchParams}`);
            if (JSON.parse(response.data) !== undefined && response.status == 200) {
                // console.log(response)
                const value = JSON.parse(response.data)
                return value
            }

        } catch (error) {
            return handleError(error);
        }
    }


    /**
     * Create a match
     * @param params Object with match params
     * @returns 201 and location header - /match/1
     */
    const createMatch = async (params: any) => {
        try {
            const response = await axiosInstance().post(`gamemanager/matches`, params);
            if (response.status == 200) {
                return response.headers.location
            }
        } catch (error) {
            return handleError(error)
        }
    }


    /**
     * Get match status by match ID
     * @param id match Id - string
     * @returns Object with match content
     * {
        "match": {
            "id": "1",
            "name": "Test Match",
            "startDate": "2021-01-05T10:00Z",
            "endDate": "2021-01-05T18:00Z",
            "homeTeam": {
            "id": "1",
            "name": "AUS"
            },
            "awayTeam": {
            "id": "1",
            "name": "AUS"
            },
            "status": {
            "day": 1,
            "session": 1,
            "state": "IN_PROGRESS"
            },
            "result": "HOME_WIN"
        },
        "innings": [ object ]
        }
     */
    const getMatchStatusById = async (id: any) => {
        try {
            return await axiosInstance().get(`gamemanager/matches/${id}/status`)
        } catch (error) {
            return handleError(error)
        }
    }

    /**
     * Get deliveries for a given range of overs in a innings
     * @param id match Id - string
     * @param inningsNumber number
     * @param startOver number
     * @param endOver number
     * @param count number
     * @param after string
     * @param before string
     * @param reverse boolean
     * @returns Object with list of deliveries for a given over range
     * {
    "cursor": "abc",
    "count": 10,
    "data": [
        {
        "number": 1,
        "ball": 1,
        "over": 50,
        "innings": 1,
        "newBallTaken": true,
        "runs": 4,
        "boundaryRuns": [
            4
        ],
        "isValid": true,
        "freeHit": true,
        "noballs": 0,
        "wides": 0,
        "byes": 0,
        "legbyes": 0,
        "striker": {
            "id": "1",
            "name": "Steve Smith"
        },
        "nonStriker": {
            "id": "2",
            "name": "David Warner"
        },
        "bowler": {
            "id": "3",
            "name": "Pat Cummins"
        },
        "powerplay": true,
        "bowlingEnd": "NORTH",
        "bowlingSpeed": 140.8,
        "dismissal": [object]
        }
    ]
    }
     */
    const getDeliveriesByInnings = async (id: any, inningsNumber: any, startOver: any, endOver: any, count: any, after: any, before: any, reverse: any) => {
        try {
            return await axiosInstance().get(`gamemanager/matches/${id}/innings/${inningsNumber}/deliveries?startOver=${startOver}&endOver=${endOver}&count=${count}&after=${after}&before=${before}&reverse=${reverse}`)
        } catch (error) {
            return handleError(error)
        }
    }

    /**
     * Get Over summaries for a given range of overs in a innings
     * @param id match Id - string
     * @param inningsNumber number
     * @param startOver number
     * @param endOver number
     * @param count number
     * @param after string
     * @param before string
     * @param reverse boolean
     * @returns Object with list of overs for a given over range
     * 
    {
        "cursor": "abc",
        "count": 10,
        "data": [
            {
            "number": 50,
            "innings": 1,
            "balls": 6,
            "runs": 10,
            "fours": 1,
            "sixes": 0,
            "wickets": 1,
            "extras": {
                "noballs": 0,
                "wides": 0,
                "byes": 0,
                "legbyes": 0
                }
            }
        ]
    }
     */
    const getOversByInning = async (id: any, inningsNumber: any, startOver: any, endOver: any, count: any, after: any, before: any, reverse: boolean) => {
        try {
            return await axiosInstance().get(`gamemanager/matches/${id}/innings/${inningsNumber}/overs?startOver=${startOver}&endOve=${endOver}&count=${count}&after=${after}&before=${before}&reverse=${reverse}`)
        } catch (error) {
            return handleError(error)
        }
    }



    /**
     * 
     * Players
     * 
     */

    /**
     * Get a player by ID
     * @param id string
     * @returns Object with player content
     * {
        "id": "1",
        "firstName": "John",
        "middleNames": [
            "James"
        ],
        "lastName": "Smith",
        "name": "John Smith",
        "nickName": "Smudge",
        "dateOfBirth": "1989-06-02",
        "gender": "Male",
        "battingHand": "Left",
        "bowlingStyle": "RF",
        "country": "AUS"
        }
     */
    const getPlayerById = async (id: any) => {
        try {
            return await axiosInstance().get(`/players/${id}`)
        } catch (error) {
            return handleError(error)
        }
    }

    /**
     * Get a list of players
     * @param params object of search params
     * @returns List of players
     * {
        "cursor": "abc",
        "count": 10,
        "data": [
            {
            "id": "1",
            "firstName": "John",
            "middleNames": [
                "James"
            ],
            "lastName": "Smith",
            "name": "John Smith",
            "nickName": "Smudge",
            "dateOfBirth": "1989-06-02",
            "gender": "Male",
            "battingHand": "Left",
            "bowlingStyle": "RF",
            "country": "AUS"
            }
        ]
        }
     */
    const getAllPlayers = async (params?: any) => {
        try {
            const searchParams = new URLSearchParams(params)
            return await axiosInstance().get(`/players?${searchParams}`)
        } catch (error) {
            return handleError(error)
        }
    }


    /**
    * Create a Player
    * @param params Object with player params
    * @returns 201 and location header - /players/1
    */
    const createPlayer = async (params: any) => {
        try {
            const response = await axiosInstance().post(`/players`, params);
            if (response.status == 200) {
                return response.headers.location
            }
        } catch (error) {
            return handleError(error)
        }
    }



    /**
     * 
     * Umpires
     * 
     */

    /**
     * Get an umpire by ID
     * @param id string
     * @returns Object with umpire content
     * {
        "id": "1",
        "firstName": "John",
        "middleNames": [
            "James"
        ],
        "lastName": "Smith",
        "name": "John Smith",
        "nickName": "Smudge",
        "dateOfBirth": "1989-06-02",
        "gender": "Male",
        "country": "AUS"
        }
     */
    const getUmpireById = async (id: any) => {
        try {
            return await axiosInstance().get(`gamemanager/umpires/${id}`);
        } catch (error) {
            return handleError(error)
        }
    }


    /**
     * Get a list of umpires
     * @param params object of optional search params
     * @returns List of umpires
     */
    const getAllUmpires = async (params?: any) => {
        try {
            const searchParams = new URLSearchParams(params)
            return await axiosInstance().get(`gamemanager/umpires?${searchParams}`)
        } catch (error) {
            return handleError(error)
        }
    }

    /**
        * Create an umpire
        * @param params Object with umpire params
        * @returns 201 and location header - /umpires/1
        */
    const createUmpire = async (params: any) => {
        try {
            const response = await axiosInstance().post(`gamemanager/umpires`, params);
            if (response.status == 200) {
                return response.headers.location
            }
        } catch (error) {
            return handleError(error)
        }
    }

    /**
     * 
     * Teams 
     * 
     */


    /**
     * Get a team by ID
     * @param id string
     * @returns Object with team content
     * {
        "id": "1",
        "name": "Australia",
        "teamCode": "AUS",
        "country": "AUS",
        "league": "Big Bash League"
        }
     */
    const getTeamById = async (id: any) => {
        try {
            return await axiosInstance().get(`gamemanager/teams/${id}`);
        } catch (error) {
            return handleError(error)
        }
    }


    /**
     * Get a list of teams
     * @param params object of optional search params
     * @returns list of teams
     * {
        "cursor": "abc",
        "count": 10,
        "data": [
            {
            "id": "1",
            "name": "Australia",
            "teamCode": "AUS",
            "country": "AUS",
            "league": "Big Bash League"
            }
        ]
        }
     */
    const getAllTeams = async (params?: any) => {
        try {
            const searchParams = new URLSearchParams(params)
            return await axiosInstance().get(`gamemanager/teams?${searchParams}`)
        } catch (error) {
            return handleError(error)
        }
    }

    /**
    * Create a Team
    * @param params Object with team params
    * @returns 201 and location header - /teams/1
    */
    const createTeam = async (params: any) => {
        try {
            const response = await axiosInstance().post(`gamemanager/teams`, params);
            if (response.status == 200) {
                return response.headers.location
            }
        } catch (error) {
            return handleError(error)
        }
    }

    /**
     * Get a list of squad players by Team ID
     * @param teamId string - id of team
     * @returns list of players
     * {
        "cursor": "abc",
        "count": 10,
        "data": [
        {
            "id": "01J4G4CZ9W9PPH90C7FJ3P20BA",
            "legacyId": 1514,
            "firstName": "Usman",
            "middleNames": [
                "Tariq"
            ],
            "lastName": "Khawaja",
            "name": "Usman Khawaja",
            "nickNames": [
                "Usie"
            ],
            "dateOfBirth": "1986-12-18",
            "gender": "Male",
            "battingHand": "Left",
            "bowlingStyle": "RM",
            "playingRole": "Top order Batter",
            "country": "AUS"
        }
    ]}
     */
    const getSquadByTeamId = async (teamId: any) => {
        try {
            return await axiosInstance().get(`gamemanager/teams/${teamId}/players`);
        } catch (error) {
            return handleError(error)
        }
    }

    /**
    * Add a player to a teams squad
    * @param teamId Id of team player will be added to
    * @param params Object with players ID - { "playerId": <player-id> }
    * @returns 201
    */
    const addPlayerToTeam = async (teamId: any, params: any) => {
        try {
            return await axiosInstance().post(`gamemanager/teams/${teamId}/players`, params);
        } catch (error) {
            return handleError(error)
        }
    }

    /**
     * 
     * Venues
     * 
     */

    /**
     * Get a venue by ID
     * @param id string
     * @returns Object with venue content
     * {
        "id": "1",
        "name": "Sydney Cricket Ground",
        "city": "Sydney",
        "region": "New South Wales",
        "country": "AUS",
        "capacity": 48000,
        "location": {
            "latitude": -33.889,
            "longitude": 151.216
        }
        }
     */
    const getVenueById = async (id: any) => {
        try {
            return await axiosInstance().get(`gamemanager/venues/${id}`)
        } catch (error) {
            return handleError(error)
        }
    }

    /**
     * Get a list of venues
     * @param params - object of optional params
     * @returns List of teams
     * {
        "cursor": "abc",
        "count": 10,
        "data": [
            {
            "id": "1",
            "name": "Sydney Cricket Ground",
            "city": "Sydney",
            "region": "New South Wales",
            "country": "AUS",
            "capacity": 48000,
            "location": {
                "latitude": -33.889,
                "longitude": 151.216
            }
            }
        ]
        }
     */
    const getAllVenues = async (params?: any) => {
        try {
            const searchParams = new URLSearchParams(params)
            return await axiosInstance().get(`gamemanager/venues?${searchParams}`)
        } catch (error) {
            return handleError(error)
        }
    }

    /**
    * Create a Venue
    * @param params Object with venue params
    * @returns 201 and location header - /venues/1
    */
    const createVenue = async (params: any) => {
        try {
            const response = await axiosInstance().post(`gamemanager/venues`, params);
            if (response.status == 200) {
                return response.headers.location
            }
        } catch (error) {
            return handleError(error)
        }
    }

    const handleError = (error: any) => {
        console.error(error);
        return Promise.reject(error);
    }

    return {
        getMatchById,
        getAllMatches,
        getMatchStatusById,
        getDeliveriesByInnings,
        getOversByInning,
        getPlayerById,
        getAllPlayers,
        getUmpireById,
        getAllUmpires,
        getTeamById,
        getAllTeams,
        getVenueById,
        getAllVenues,
        getSquadByTeamId,
        createMatch,
        createPlayer,
        createUmpire,
        createTeam,
        addPlayerToTeam,
        createVenue,
    }

})